export const GET_VIDEO_CALL_QUALITY_PROFILES = 'GET_VIDEO_CALL_QUALITY_PROFILES';
export const GOT_VIDEO_CALL_QUALITY_PROFILES = 'GOT_VIDEO_CALL_QUALITY_PROFILES';
export const ERROR_GETTING_VIDEO_CALL_QUALITY_PROFILES = 'ERROR_GETTING_VIDEO_CALL_QUALITY_PROFILES';
export const SET_ALL_PORTAL_SETTINGS = 'SET_ALL_PORTAL_SETTINGS';
export const SET_SELECTED_PORTAL_VALUE = 'SET_SELECTED_PORTAL_VALUE';
export const PORTAL_SETTING_LOADER = 'PORTAL_SETTING_LOADER';
export const REFETCH_PORTAL_SETTING_INDICATOR = 'REFETCH_PORTAL_SETTING_INDICATOR';
import fc from '../businessLogic/fetchInterceptor';
import { displayGlobalMessage } from '../actions/globalMessage';
import { EDIT_UPDATE_PORTAL_SETTING } from '../actions/modal';
import { queueESEvents, ESEventTypes } from '../businessLogic/logEventToElasticSearch';

//if permission is sent empty, then we load all the groups based upon the logged in user viewable groups.
export function getCallQualityProfiles(cb) {
  return (dispatch) => {
    dispatch({ type: GET_VIDEO_CALL_QUALITY_PROFILES });
    var apiPart = 'portalSettings/VideoCallQualityProfiles';

    fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
      .then((data) => {
        let res = dispatch({
          type: GOT_VIDEO_CALL_QUALITY_PROFILES,
          data: data,
        });
        if (cb) cb();
        return res;
      })
      .catch((err) => {
        console.error('There was an error getting the call quality profiles', err.toString());
        queueESEvents(ESEventTypes.CallQualityProfiles, err.toString());
      });
  };
}
//Portal setting loading indicator
export function managePortalSettingLoader(data) {
  return (dispatch) => {
    dispatch({
      type: PORTAL_SETTING_LOADER,
      data: data,
    });
  };
}
//Selected Portal Value
export function setSelectedPortalSettingValue(portalValue) {
  return (dispatch) => {
    dispatch({
      type: SET_SELECTED_PORTAL_VALUE,
      data: portalValue,
    });
  };
}
export function setAllNewPortalSettingValues(data) {
  return (dispatch) => {
    dispatch({
      type: SET_ALL_PORTAL_SETTINGS,
      data: data,
    });
  };
}
// Getting portal settings
export function getAllPortalSettings(cb) {
  return (dispatch) => {
    //Set the loader initially false
    dispatch({
      type: PORTAL_SETTING_LOADER,
      data: true,
    });
    const apiParam = 'portalSettings/Settings';
    fc.get(window.APP.CONFIGURATION.VCCAPI + apiParam)
      .then((data) => {
        dispatch({
          type: REFETCH_PORTAL_SETTING_INDICATOR,
          data: false,
        });
        dispatch({
          type: PORTAL_SETTING_LOADER,
          data: false,
        });
        dispatch({
          type: SET_ALL_PORTAL_SETTINGS,
          data: data,
        });
        if (cb) cb();
      })
      .catch((err) => {
        dispatch({
          type: PORTAL_SETTING_LOADER,
          data: false,
        });
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.DeleteOrganization.ErrorMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
            autoHide: true,
          })
        );
        console.error('There was an API error', err.toString());
      });
  };
}
// Saving/Updating portal settings
export function updatePortalSetting(portalSetting, cb) {
  return (dispatch) => {
    const apiParam = 'portalSettings';
    fc.post(window.APP.CONFIGURATION.VCCAPI + apiParam, {
      body: JSON.stringify(portalSetting),
    })
      .then((data) => {
        dispatch(getAllPortalSettings());
        dispatch({
          type: EDIT_UPDATE_PORTAL_SETTING,
          data: false,
        });
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.AdminMenu.portalSettingSuccessMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
        if (cb) cb();
      })
      .catch((err) => {
        dispatch({
          type: EDIT_UPDATE_PORTAL_SETTING,
          data: false,
        });
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.DeleteOrganization.ErrorMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
            autoHide: true,
          })
        );
        console.error('There was an API error', err.toString());
      });
  };
}

export function getGoogleAnalyticsId(cb) {
  var apiPart = 'portalSettings/googleanalyticstrackingid';

  fc.get(window.APP.CONFIGURATION.VCCAPI + apiPart)
    .then((data) => {
      //the data contains the google analytics id
      if (cb) cb(data);
    })
    .catch((err) => {
      console.error('There was an error getting the google Analytics Id', err);
      queueESEvents(ESEventTypes.GetGAIdError, err.toString());
    });
}
